import React from 'react';
import { NavHashLink } from 'react-router-hash-link';
import useMain from '../../hooks/useMain';

function MMP() {
	const { onHashLinkClick, theme } = useMain();
	return (
		<div
			id='mmpCarousel'
			className='carousel slide'
			data-bs-ride='carousel'>
			<div className='carousel-indicators'>
				<button
					type='button'
					data-bs-target='#mmpCarousel'
					data-bs-slide-to='0'
					className='active'
					aria-current='true'
					aria-label='Slide 1'></button>
				<button
					type='button'
					data-bs-target='#mmpCarousel'
					data-bs-slide-to='1'
					aria-label='Slide 2'></button>
				<button
					type='button'
					data-bs-target='#mmpCarousel'
					data-bs-slide-to='2'
					aria-label='Slide 3'></button>
			</div>
			<div className='carousel-inner'>
				<div
					className='carousel-item active'
					data-bs-interval='10000'>
					<MMP1
						theme={theme}
						onHashLinkClick={onHashLinkClick}
					/>
				</div>
				<div
					className='carousel-item'
					data-bs-interval='10000'>
					<MMP2
						theme={theme}
						onHashLinkClick={onHashLinkClick}
					/>
				</div>
				<div
					className='carousel-item'
					data-bs-interval='10000'>
					<MMP3
						theme={theme}
						onHashLinkClick={onHashLinkClick}
					/>
				</div>
			</div>
			<button
				className='carousel-control-prev d-none d-md-block'
				type='button'
				data-bs-target='#mmpCarousel'
				data-bs-slide='prev'>
				<span
					className='carousel-control-prev-icon'
					aria-hidden='true'></span>
				<span className='visually-hidden'>Previous</span>
			</button>
			<button
				className='carousel-control-next d-none d-md-block'
				type='button'
				data-bs-target='#mmpCarousel'
				data-bs-slide='next'>
				<span
					className='carousel-control-next-icon'
					aria-hidden='true'></span>
				<span className='visually-hidden'>Next</span>
			</button>
		</div>
	);
}

const MMP1 = ({ onHashLinkClick, theme }) => {
	return (
		<div
			id='mmp_1'
			className='d-block w-100'>
			<div className='container py-md-5'>
				<div className='row align-items-center mb-5'>
					<div className='col-md-5 pt-5 ps-sm-5'>
						<h3 className='pb-4'>
							<b>Market Maker Plan</b>
						</h3>
						<p>
							The MMP WORLD Project is a key initiative launched by the BEM Foundation
							on August 12, 2022. Operating under the foundation’s strategic vision,
							MMP WORLD is designed to function as a dual-platform system,
							incorporating both crowdfunding mechanisms and market-making services.
							Its primary mission is to support and stabilize financial markets for
							blockchain-based projects developed by the BEM Foundation.
						</p>
						<NavHashLink
							className={`btn btn-set5-${theme} me-3`}
							smooth
							scroll={onHashLinkClick}
							to={'/mmpworld#mmp_main'}>
							Read More
						</NavHashLink>
					</div>
				</div>
			</div>
		</div>
	);
};

const MMP2 = ({ onHashLinkClick, theme }) => {
	return (
		<div
			id='mmp_2'
			className='d-block w-100'>
			<div className='container py-md-5'>
				<div className='row align-items-center mb-5'>
					<div className='col-md-5 pt-5 ps-sm-5'>
						<h3 className='pb-4'>
							<b>MMP World Project</b>
						</h3>
						<p>
							MMP WORLD is a dynamic financial platform that delivers a range of
							income-generating services for users, combining investment accessibility
							with sustainable earning models. Its core focus lies in market-making
							operations, beginning with the BCN token—one of the BEM Foundation’s ten
							officially approved and ready-to-launch projects. By creating liquidity
							and controlling volatility, MMP WORLD enables a structured and
							investor-friendly environment.
						</p>
						<NavHashLink
							className={`btn btn-set5-${theme} me-3`}
							smooth
							scroll={onHashLinkClick}
							to={'/mmpworld#mmp_projects'}>
							Read More
						</NavHashLink>
					</div>
				</div>
			</div>
		</div>
	);
};

const MMP3 = ({ onHashLinkClick, theme }) => {
	return (
		<div
			id='mmp_3'
			className='d-block w-100'>
			<div className='container py-md-5'>
				<div className='row align-items-center mb-5'>
					<div className='col-md-5 pt-5 ps-sm-5'>
						<h3 className='pb-4'>
							<b>MMP World Goals</b>
						</h3>
						<p>
							The primary goal of MMP WORLD is to spearhead the global market
							expansion of the BCN token. As an experienced market maker, the platform
							is committed to injecting liquidity, narrowing spreads, and stabilizing
							the trading environment for the token. At the same time, it provides
							users with a comprehensive financial ecosystem that unlocks multiple
							avenues for profit generation in the cryptocurrency space. MMP WORLD is
							not just a technical solution—it’s a strategic engine designed to
							empower long-term growth and financial inclusion within the
							decentralized economy.
						</p>
						<NavHashLink
							className={`btn btn-set5-${theme} me-3`}
							smooth
							scroll={onHashLinkClick}
							to={'/mmpworld#mmp_goals'}>
							Read More
						</NavHashLink>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MMP;
